module.exports = __webpack_public_path__ + "img/read.37e5bcac.svg";